module.exports = __webpack_public_path__ + "static/media/carta_50.098d9c28.jpg";